export default __webpack_public_path__ + "static/clock-4b3e0917961de60b7ee9d55f5cb034c4.jpg";